import { ca } from '@cian/analytics';

interface ITrackClick {
  label: string;
  offerId: number;
}

export function trackClick({ label, offerId }: ITrackClick) {
  return ca('eventSite', {
    name: 'oldevent',
    category: 'Compare',
    action: 'click',
    label,
    products: [{ id: offerId, offerType: 'offer' }],
  });
}
